/**
 * Shared Burn Rate / Headcount / Staff Rate chart tooltip helpers.
 */

/**
 * Prefer row date/month; if blank, fall back to response-level datatime ("Updated on").
 */
export const resolveMetricTooltipDate = (
  rowDate?: string | null,
  rowMonth?: string | null,
  fallbackDatatime?: string | null,
): string => rowDate || rowMonth || fallbackDatatime || '';

export const resolveActualForecastStyle = (input: {
  isActual?: number | null;
  source?: string | null;
}): {
  useForecastStyle: boolean;
  tooltipHeaderRight: 'Actual' | 'Forecast' | 'Actual + Forecast' | '';
} => {
  const useForecastStyle = input.isActual === 0 || input.source === 'forecast' || input.source === 'mixed';

  // let tooltipHeaderRight = 'Actual + Forecast';

  let tooltipHeaderRight: 'Actual' | 'Forecast' | 'Actual + Forecast' | '' = '';

  if (input.source === 'actual') {
    tooltipHeaderRight = 'Actual';
  } else if (input.source === 'forecast') {
    tooltipHeaderRight = 'Forecast';
  } else if (input.source === 'mixed') {
    tooltipHeaderRight = 'Actual + Forecast';
  }

  return {
    useForecastStyle,
    tooltipHeaderRight,
  };
};
